const MuiSkeletonOverrides = {
  MuiSkeleton: {
    defaultProps: {
      style: {
        borderRadius: '2px'
      }
    }
  }
};

export { MuiSkeletonOverrides };
